
let io = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting  === true) {
      modify(entry.target);
    } else {
      revert(entry.target);
    }
  })


 
}, {
  threshold: 0.1
})

function modify(el) {
  if (el.id === "journey") {
    $('.journey').addClass('active');$('.custom-nav').removeClass('color-white');
  }else{$('.custom-nav').addClass('color-white');}
  if (el.id === "team") {
       $('.team').addClass('active');
  }
    if (el.id === "values") {
         $('.values').addClass('active');
  }
    if (el.id === "partners") {
         $('.partners').addClass('active');

  }
}

function revert(el) {
   if (el.id === "journey") {
    $('.journey').removeClass('active');
  }
  if (el.id === "team") {
       $('.team').removeClass('active');
  }
    if (el.id === "values") {
         $('.values').removeClass('active');
  }
    if (el.id === "partners") {
         $('.partners').removeClass('active');

  }
}

  

window.addEventListener('scroll', function() {
	var element = document.querySelector('#journey');
	var position = element.getBoundingClientRect();
  
	if((position.top+200) < window.innerHeight ) {
		$('.custom-nav').css('display', 'flex');

      
	}else{$('.custom-nav').hide();}
});


var observer2 = new IntersectionObserver(function(entries) {
	// isIntersecting is true when element and viewport are overlapping
	// isIntersecting is false when element and viewport don't overlap
	if(entries[0].isIntersecting === true)
		$('.custom-nav').addClass('important-hidden'); else $('.custom-nav').removeClass('important-hidden');
}, { threshold: [0.5] });

var observer_color_change = new IntersectionObserver(function(entries) {
	// isIntersecting is true when element and viewport are overlapping
	// isIntersecting is false when element and viewport don't overlap
	if(entries[0].isIntersecting === true){
$('div.timeline_custom_new, .count__time, .count__timeer, .timer__bl').css('background-color','#BCCBD2');
      
    }else{
$('div.timeline_custom_new, .count__time, .count__timeer, .timer__bl').css('background-color','#f1ede0');
      
    }

}, { threshold: 0 });


window.addEventListener("DOMContentLoaded",function(){
io.observe(document.querySelector("#journey"));
  io.observe(document.querySelector("#team"));
  io.observe(document.querySelector("#values"));
  io.observe(document.querySelector("#partners"));
  observer2.observe(document.querySelector(".image-with-text.hell.page-width.color-scheme-background-1"));




var element_position = $('#journey [data-story]:nth-child(9)').offset().top;
var screen_height = $(window).height();
var activation_offset = 0.5;//determines how far up the the page the element needs to be before triggering the function
var activation_point = element_position - (screen_height * activation_offset);


//Does something when user scrolls to it OR
//Does it when user has reached the bottom of the page and hasn't triggered the function yet
$(window).on('scroll', function() {
    var y_scroll_pos = window.pageYOffset;

    var element_in_view = y_scroll_pos > activation_point;


    if(element_in_view) {
  
$('div.timeline_custom_new, .count__time, .count__timeer, .timer__bl').css('background-color','#BCCBD2');
      
    }else{
$('div.timeline_custom_new, .count__time, .count__timeer, .timer__bl').css('background-color','#f1ede0');

      
    }
});
$(window).scroll(function() {
   console.log($(this).scrollTop());


var max_top = $(window).width()<600?400:700;
  
if($(this).scrollTop() > 1400){

var scrolled = $(this).scrollTop()/10;

var top = max_top - scrolled;

if(top<0) top = 0;

$('.parallax-container').css('top',top);

}else{

  $('.parallax-container').css('top',max_top);
}
 
});

  
});